import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Download, FileText, Image as ImageIcon } from 'lucide-react';

const isImageFile = (fileName) => {
  if (!fileName) return false;
  return /\.(png|jpg|jpeg|gif|webp|bmp|svg)$/i.test(fileName);
};

export const SubmittalPreviewModal = ({ open, onClose, submittal, onDownload }) => {
  if (!submittal) return null;
  const fileName = submittal.fileName || '';
  const isPdf = fileName.toLowerCase().endsWith('.pdf');
  const isImage = isImageFile(fileName);
  const previewUrl = submittal.cloudinaryUrl || submittal.url;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl h-[80vh] flex flex-col p-0" data-testid="submittal-preview-modal">
        <DialogHeader className="px-4 pt-4 pb-2 border-b shrink-0">
          <DialogTitle className="flex items-center gap-2 text-sm font-medium">
            {isImage ? <ImageIcon className="h-4 w-4 text-slate-400" /> : <FileText className="h-4 w-4 text-slate-400" />}
            <span className="truncate flex-1">{fileName}</span>
            {onDownload && (
              <Button variant="outline" size="sm" onClick={() => onDownload(submittal.id, submittal.fileName, submittal.bytes)} data-testid="preview-download-btn">
                <Download className="h-3.5 w-3.5 mr-1.5" />Download
              </Button>
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-hidden p-2">
          {isPdf && previewUrl ? (
            <iframe src={previewUrl} className="w-full h-full rounded border" title={fileName} data-testid="submittal-preview-iframe" />
          ) : isImage && previewUrl ? (
            <div className="flex items-center justify-center h-full bg-slate-50 rounded" data-testid="submittal-preview-image">
              <img src={previewUrl} alt={fileName} className="max-w-full max-h-full object-contain rounded" />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-slate-400 gap-3" data-testid="submittal-preview-fallback">
              <FileText className="h-12 w-12" />
              <p className="text-sm">Preview not available for this file type</p>
              {onDownload && (
                <Button variant="outline" size="sm" onClick={() => onDownload(submittal.id, submittal.fileName, submittal.bytes)}>
                  <Download className="h-3.5 w-3.5 mr-1.5" />Download File
                </Button>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
